import React, { useState } from 'react';

const withProducts = Component => props => {
    const [selectedProduct, setSelectedProduct] = useState('all');

    return <Component product={selectedProduct} setProduct={setSelectedProduct} {...props} />;
};

export default withProducts;
